// 追梦中国相关页面
export const ROUTE_NAME = {
    INDEX: 'INDEX',
    HOME: 'HOME',
    INVITATION: 'INVITATION',
};

const STATIC_HOST = 'https://static.run100.runorout.cn';
export const STATIC_HOST_TRIANGLE = `${STATIC_HOST}/static/img/triangle`;

export function getTriangleImg(name: string) {
    return `${STATIC_HOST_TRIANGLE}/${name}`;
}
